export const setLoggedInUser = (user, dispatch) =>
  dispatch({ type: 'SET_LOGGED_IN_USER', payload: user });

export const setLocation = (location, dispatch) =>
  dispatch({ type: 'SET_LOCATION', payload: location });
